<template>
            <!---- Start Preview ---->
            <v-row align="center" justify="center">
            <v-col cols="12" sm="12" md="12">
            <div class="row justify-content-center border">
              <table width="95%" style="border:1px solid #b3d4fc;">
                <tr>
                  <td colspan="3">
                      <div class="header-content pa-0">
                        <div class="col-12 pa-0">
                            <img width="100%"  :src="headersection" >
                        </div>
                      </div>  
                    </td>  
                </tr>
                <tr>
                  <td colspan="2" class="pa-0" style="vertical-align:top;" width="70%">
                   <div class="col-lg-12 col-md-12 pa-0 left-content">
                     <img  width="100%" :src="leftsection" >
                   </div>
                  </td>
                   <td width="30%" :style="{ 'vertical-align':'top', 'background-image': 'url(' + rightsection + ')','background-size':'100% 97%' }">
                            <div class="col-lg-12 col-md-12 draggablecontent" :style="{ 'background-image': 'url(' + adhere + ')' }"  >
                              <div class="postionsection" >
                                  <div class="bannercontenthtml bannercontentimage" v-html="bannercontent">
                                  </div>
                              </div>    
                            </div>
                    </td>  
                </tr>  
            </table>   
            </div>
            </v-col>
        </v-row>
      <!---- End Preview ---->
  </template>
<script> 
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

//var adserverURL ="http://local.adserver.com/www/";

  export default {
    name: 'Myyaaktemplate',
    props:[
       'bannercontent',
    ],
    components: {
           
        },
    data: () => ({
      headersection : require("@/assets/riskheadersection.png"),
      leftsection : require("@/assets/riskleftsection.png"),
    //  middlesection:  require("@/assets/middlesection.png"),
      rightsection :  require("@/assets/riskrightsection.png"),
      adhere: require("@/assets/506.jpg"),
     }),
      mounted() {
     },
   computed:{
     baseURL() {
              const url = process.env.VUE_APP_BASEAPI.slice(0, -4);
              return url;
            }
     },
    methods: { 
    }
  }
</script>
<style scoped>
.row {
  margin-left: 0px;
}
.padding-top-0{padding-top: 0px !important;}
.padding-right-0{padding-right: 0px !important;}
.padding-bottom-0{padding-bottom: 0px !important;}    
.draggable-list {
  color: #fff;
  border: 1px solid;
  height: 150px;
}
.header-content{width:100%;height: 22px;}
.left-content{padding-top:0px;padding-right:0px; }
.center-content{height: 100%;}
.right-content{height: 100%;}
.footer-content{height: 100%; border:1px solid #b3d4fc;}
.draggablecontent{background-size: 100% 100%;}
.bannercontentimage{width:100%;height:100%;position: relative;top:10%;}
.bannercontenthtml{width:100%;height:100%;position: relative;color:#000; background-color: #fff;}
.postionsection{width: 100%;height: 100%;}
</style>